import { getCompanyURL } from '@general/entities/company';
import { transformLocation } from '@general/location';

export const mapSearchCompanyToProps = ({ hit, isFavorite, onClick }) => {
    const id = parseInt(hit.objectID.split('-')[1], 10);
    return {
        id,
        logoUrl: hit.logo_url,
        name: hit.company_name,
        displayLocation: transformLocation(hit.location),
        url: getCompanyURL(id),
        isFavorite,
        onClick,
        businessType: hit.business_type,
    };
};

export const mapGraphCompanyToProps = company => ({
    id: company.recordId,
    name: company.name,
    logoUrl: company.logoUrl,
    displayLocation: transformLocation(company.addresses.find(address => address.purpose === 'main')),
    url: getCompanyURL(company.recordId),
    businessType: [company.primaryBusinessType.name],
    isFavorite: true,
});

export const mapGraphCompanyToForm = company => {
    const { addresses, primaryBusinessType, secondaryBusinessTypes, minorityOwned, womanOwned, ...rest } = company;

    const secondaryBusinessTypesParsed = secondaryBusinessTypes.map(type => {
        const name = type.name || '';
        return name.includes('-') ? name.split('-')[0] : name;
    });

    const mainAddress = addresses.find(({ purpose }) => purpose === 'main');

    return {
        mainAddress: {
            country: mainAddress ? mainAddress.country : '',
            address: mainAddress ? mainAddress.address : '',
            address2: mainAddress ? mainAddress.address2 : '',
            address3: mainAddress ? mainAddress.address3 : '',
            city: mainAddress ? mainAddress.city : '',
            stateProvince: mainAddress ? mainAddress.stateProvince : '',
            zip: mainAddress ? mainAddress.zip : '',
            preferredBilling: mainAddress ? mainAddress.preferredBilling : true,
            preferredMailing: mainAddress ? mainAddress.preferredMailing : true,
        },
        minorityOwned: minorityOwned ? '1' : '0',
        primaryBusinessType: primaryBusinessType?.code,
        secondaryBusinessTypes: secondaryBusinessTypesParsed,
        womanOwned: womanOwned ? '1' : '0',
        ...rest,
    };
};
